<div class="main-container">
  <div class="top-bar">
    <div class="top-bar-item">
      <p-button label="Add new" routerLink="/management/create-link"></p-button>
      <p-button [disabled]="!selectedLink" (onClick)="delete()" label="Delete selected item"></p-button>
    </div>
</div>

  <p *ngIf="selectedLink">
    Selected: {{selectedLink.name}}
  </p>

  <div *ngFor="let link of linkItems" (click)="select(link)" class="link-item">
    <span>
      {{link.name}}
    </span>
    <span>
      {{link.url}}
    </span>
  
  </div>
</div>
